<template>
 <div class="login">
   <div class="logo">
      <img src="~@/assets/flux-logo.svg">
   </div>
   <div class="form">
     <el-form>
      <el-form-item>
        <el-input v-model="username" placeholder="Username" required autofocus>
          <font-awesome-icon icon="user" slot="suffix" />
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="password" type="password" required placeholder="Password">
          <font-awesome-icon icon="key" slot="suffix" />
        </el-input>
      </el-form-item>
      <el-form-item >
        <el-input v-model="url" placeholder="Server Address">
          <font-awesome-icon icon="server" slot="suffix" />
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="login">Login</el-button>
        <a href="#" @click="forgotPassword">Forgot password?</a>
      </el-form-item>
    </el-form>
   </div>
   <el-dialog title="Forgot Password?" :visible.sync="forgotPasswordDialogIsVisible" width="500px" class="forgot-password-dialog" :close-on-click-modal="false">
    Enter your email address below to reset the password for your Flux account.
      <el-form ref="form" label-width="45px">
        <el-form-item label="Email">
          <el-input v-model="email" :class="{ invalid: !emailIsValid }" ref="email"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="forgotPasswordDialogIsVisible = false">Cancel</el-button>
          <el-button @click="requestPasswordReset" type="primary" :disabled="!emailIsValid">Submit</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
 </div>
</template>

<script>
// import axios from 'axios'
import { getDateRangeFromRangeIndex } from '@/utils/timeRange'

export default {
  data () {
    return {
      username: this.$store.state.authentication.username || '',
      password: '',
      url: this.$store.state.authentication.baseUrl || '',
      forgotPasswordDialogIsVisible: false,
      email: null
    }
  },
  methods: {
    keypress (e) {
      if (e.keyCode === 13 && !e.srcElement.closest('.el-message-box__wrapper')) {
        this.forgotPasswordDialogIsVisible && this.requestPasswordReset()
        !this.forgotPasswordDialogIsVisible && this.login()
      }
    },
    login () {
      let username = this.username
      let password = this.password
      let url = this.url
      this.$store.dispatch('login', { username, password, url })
        .then(() => {
          this.$store.commit('updateCurrentDateRange', getDateRangeFromRangeIndex('week', 0))
          this.$router.push('/')
        })
        .catch(() => this.$message.error('Invalid username or password.'))
    },
    forgotPassword () {
      this.email = null
      this.forgotPasswordDialogIsVisible = true
      this.$nextTick(() => this.$refs['email'].focus())
    },
    requestPasswordReset () {
      this.$alert('This feature has not been fully implemented. Please check back later.', 'Password Reset Coming Soon', {
        confirmButtonText: 'OK'
      })
      // uncomment this code when the back end has been implemented
      // let url = `${this.$store.state.authentication.baseUrl}/reset-email`
      // let data = {
      //   email: this.email,
      //   subject: 'Flux Password Reset',
      //   body: `You have requested to reset your password for your Flux account. Please click on the link below to reset your password.\n\n${this.$store.state.authentication.baseUrl}/reset-password/{token}\n\nThank you,\nThe Flux Team`
      // }
      // axios({ url: url, data: data, method: 'POST' })
      //   .then(response => {
      //     this.forgotPasswordDialogIsVisible = false
      //     this.$alert('A request to reset your Flux account password has been received. A password reset link will be sent to your email address.', 'Request Sent', {
      //       confirmButtonText: 'OK',
      //       type: 'success'
      //     })
      //   })
      //   .catch(() => this.$message.error('Flux account not found.'))
    }
  },
  computed: {
    emailIsValid () {
      return !this.email || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email)
    }
  },
  created () {
    document.addEventListener('keypress', this.keypress)
  },
  mounted () {
    if (this.$route.query.resetToken) {
      this.$alert('Your password has been successfully reset. Please login again.', 'Password Reset Successful', {
        confirmButtonText: 'OK',
        type: 'success'
      })
    }
  },
  destroyed () {
    document.removeEventListener('keypress', this.keypress)
  }
}
</script>

<style lang='scss' >
  @import "../styles/common.scss";

  .login {
    .logo {
      height: 200px;
      background-color: #2E314A;
      display: flex;
      align-items: flex-end;
      justify-content: center;
    
      img {
        height:90px;
        width:200px;
        margin-bottom: 20px;
      }
    }
    .form {
      text-align: center;

      form {
        display: inline-block;
        width: 300px;
        margin-top: 30px;

        button {
          width: 100%;
        }
      }
    }
  }
  .forgot-password-dialog {
    
    .el-dialog__body {
      padding-top: 20px;

      .el-form {
        margin-top: 20px;

        .el-form-item:last-child {
          margin-bottom: 0px;
          text-align: right;
        }
        .invalid input:focus {
          border-color: $light-red;
        }
      }
    }
  }
</style>
